import React from 'react'
import ImageItem from './ImageItem'
import './../styles/ImagesList.css'
import { motion } from "framer-motion"

function ImagesList(props) {
	const { images, removeHandler } = props

	return (
		<div className="images-list">
			<div className="list-heading">
				<h2 tyle={{ margin: 0, padding: 0 }}>Your Board</h2>
				<h4 style={{ margin: '2px 0 0 1rem', padding: 0 }}>{images.length} Items</h4>
			</div>

			<div className="images-list-container">
					{images.length === 0 ? (
						<p>Your Board is Empty</p>
					) : (
						images.map((image) => (
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								transition={{ duration: 0.3, delay: images.indexOf(image) / 50 }}
								key={image.id}
							>
								<ImageItem
									id={image.id}
									url={image.url}
									removeHandler={removeHandler}
								/>
							</motion.div>
						))
					)}
			</div>
		</div>
	)
}

export default ImagesList
